(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-custom-jp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let swiperInstance = null;
  const swiperContainer = document.querySelector('.newSwiper');

  function initializeSwiper() {
    // 画面幅が768px未満で、まだSwiperインスタンスがなければ初期化
    if (window.innerWidth < 768 && !swiperInstance) {
      swiperInstance = new Swiper(swiperContainer, {
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.3,
        spaceBetween: 17,
        navigation: {
          nextEl: '.swiper-blog-next',
          prevEl: '.swiper-blog-prev'
        }
      });
    } 
    // 画面幅が769px以上で、Swiperインスタンスが存在すれば破棄
    else if (window.innerWidth >= 769 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  // ページ読み込み時とリサイズ時に実行
  initializeSwiper();
  window.addEventListener('resize', initializeSwiper);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let swiperInstance = null;
  const swiperContainer = document.querySelector('.newSwiper');

  function initializeSwiper() {
    // 画面幅が768px未満で、まだSwiperインスタンスがなければ初期化
    if (window.innerWidth < 768 && !swiperInstance) {
      swiperInstance = new Swiper(swiperContainer, {
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.3,
        spaceBetween: 17,
        navigation: {
          nextEl: '.swiper-blog-next',
          prevEl: '.swiper-blog-prev'
        }
      });
    } 
    // 画面幅が769px以上で、Swiperインスタンスが存在すれば破棄
    else if (window.innerWidth >= 769 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  // ページ読み込み時とリサイズ時に実行
  initializeSwiper();
  window.addEventListener('resize', initializeSwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-slideshow-custom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      centeredSlides: true,
      slidesPerView: 1.3,
      spaceBetween: 17,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          centeredSlides: false,
          spaceBetween: 60,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
